import * as XLSX from '@netsoftholdings/xlsx';

const exportFormat = ({ balances, users }) =>
  balances.map((balance) => {
    const user = users.find((user) => user.id === balance.user_id) || {};

    return {
      'User email': user.email,
      'User name': user.name,
      'Policy name': balance.policy_name,
      Balance: TimeUtils.format_duration(balance.amount, false),
    };
  });
const importFormat = (data) =>
  data.map((line) => {
    return {
      user_email: line['User email'],
      policy_name: line['Policy name'],
      amount: line.Balance,
    };
  });

export function exportBook({ balances, users }, type) {
  if (!balances || balances.length === 0) {
    // No data present, fill the headers only
    balances = [{}];
    users = [];
  }
  const worksheet = XLSX.utils.json_to_sheet(exportFormat({ balances, users }));
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, worksheet, 'Time Off Balances');
  XLSX.writeFile(wb, 'time_off_balances.' + (type || 'xls'));
}

export function importBook(file) {
  return new Promise(function (resolve, reject) {
    try {
      const reader = new FileReader();

      reader.onload = function (e) {
        const data = new Uint8Array(e.target.result);
        // `raw: true` => "If true, plain text parsing will not parse values"
        // If we remove this, formats like `01:30` don't return the expected values.
        // We relied on the behavior of `0.18.5`, but starting in `0.20.0` all the
        // date handling was changed, for more see:
        //
        // https://docs.sheetjs.com/docs/api/parse-options
        // https://docs.sheetjs.com/docs/csf/features/dates/
        const workbook = XLSX.read(data, { type: 'array', raw: true });
        const sheetName = workbook.SheetNames[0];

        resolve(importFormat(XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: '' })));
      };
      reader.readAsArrayBuffer(file);
    } catch (error) {
      reject(error);
    }
  });
}

export default {
  exportBook,
  importBook,
};
